module.exports = __webpack_public_path__ + "static/media/woman_02.8071c7b0.png";